(function($) {
  $(function() {
    var shortName;

    var pubData = $('body').data('publication');
    if (pubData) {
      //console.log('has Data attribute');

      if (pubData.toLowerCase().indexOf('sustainability') >= 0) {
        shortName = 'sustainability';
      } else {
        shortName = 'annual';
      }

      createCookie('currentPublication', shortName);
    } else {
      //console.log('no data attribute');
      if (readCookie('currentPublication')) {
        // console.log('has current publication cookie');
        shortName = readCookie('currentPublication');
      } else {
        // console.log('no current publication cookie yet');
        shortName = 'annual';
      }
    }

    $('.menu--top .menu__item').each(function() {
      if (
        $(this)
          .text()
          .toLowerCase()
          .indexOf(shortName) >= 0
      ) {
        $(this).addClass('active');
      } else {
        $(this).removeClass('active');
      }
    });

    if (shortName == 'annual') {
      $('.menu--annual').removeClass('hidden');
      $('.menu--sustainability').addClass('hidden');
    } else {
      $('.menu--sustainability').removeClass('hidden');
      $('.menu--annual').addClass('hidden');
    }

    $(document).on('click', '.menu--level-0 > .menu__item--has-children > .menu__link', function(e) {
      e.preventDefault();
      var $parent = $(this).parent();
      console.log($parent);
      $('.menu__item--has-children').not($parent).removeClass('active');
      $('.menu__item--has-children').not($parent).find('.menu--level-1').slideUp();
      $parent.toggleClass('active');
      $parent.find('.menu--level-1').slideToggle();
      //console.log($(this));
    });

    $('.js-navtoggler').click(function(){
      $(this).toggleClass('active');
      $('.menu-responsive-container').toggleClass('active');
    });

    copyElemntTo($('#top-menu'), $('.menu-responsive-container__inner'), false);
    copyElemntTo($('.header__archive'), $('.menu-responsive-container__bottom'), false);
    copyElemntTo($('.header__download'), $('.menu-responsive-container__bottom'), false);
    copyElemntTo($('#annual-menu'), $('.menu-responsive-container__inner .menu__link-text:contains("Report")').parent().parent(), true);
    copyElemntTo($('#sustainability-menu'), $('.menu-responsive-container__inner .menu__link-text:contains("Sustain")').parent().parent(), true);

    function copyElemntTo(cloneElement, appendtoElement, insertAfter){
      var copy = cloneElement.clone();
      copy.attr('id', '');
      if(insertAfter != true){
        appendtoElement.append(copy);
      } else {
        appendtoElement.after(copy);
      }
    }



    /**
     * Searchform
     */

    const $searchform = $('#searchbox');
    const $searchformTrigger = $searchform.find('.searchform__trigger');

    $searchformTrigger.on('click', function() {
      $searchform.toggleClass('searchform--open');
      return false;
    });

    $searchform.on('submit', function() {
      const val = $(this)
        .find('[name=s]')
        .val();
      //console.log(val);
      if (val === '') {
        return false;
      }
    });

  });

  function createCookie(name, value, days) {
    var expires;

    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      encodeURIComponent(name) +
      '=' +
      encodeURIComponent(value) +
      expires +
      '; path=/';
  }

  function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0)
        return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
  }

  function eraseCookie(name) {
    createCookie(name, '', -1);
  }
})(jQuery);
